import appRoutes from '../../routes/exams/gmat-focus/app-routes';
import AppRoutes from '../config/AppRoutes';

export const examRedirectRoute = {
  cfa: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2022: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2023: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2024: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2025: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2026: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2027: AppRoutes.CFA1_2025_DASHBOARD,
  cfa_2_2025: AppRoutes.CFA2_2025_DASHBOARD,
  cfa_2_2026: AppRoutes.CFA2_2025_DASHBOARD,
  // CFA2 2027 has its own separate view tree (not shared like CFA1 2027) → land on the 2027 dashboard.
  cfa_2_2027: AppRoutes.CFA2_2027_DASHBOARD,
  cfa_3: AppRoutes.CFA3_DASHBOARD_2025,
  cfa_3_2025: AppRoutes.CFA3_DASHBOARD_2025,
  cfa_3_2026: AppRoutes.CFA3_DASHBOARD_2025,
  frm: AppRoutes.FRM_DASHBOARD,
  soa_p: AppRoutes.SOA_PROBABILITY_DASHBOARD,
  soa_fm: AppRoutes.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
  gmat: appRoutes.DASHBOARD,
  gmat_focus: appRoutes.DASHBOARD,
  ea: AppRoutes.EA_DASHBOARD,
  esg: AppRoutes.ESG_DASHBOARD,
};



// WEBPACK FOOTER //
// ./src/views/Common/examRedirectRoute.js